<script setup>
const bg = [
  'bg-gradient-to-r',
  'from-indigo-600',
  'to-blue-400',
]

const configs = useRuntimeConfig().public
const siteWatermark = configs.siteWatermark
</script>

<template lang="pug">
div(:class="[...bg]").py-16.mb-6
  AppContainer.relative
    div.absolute.-top-4.bg-clip-text.text-transparent.bg-gradient-to-r.from-primary-200.text-3xl.font-black.italic {{ siteWatermark }}
    div.text-white.font-bold.text-4xl.ml-24.relative
      slot
</template>
